import React, { useEffect } from 'react'
import "./LetsGetStarted.css"
import { useNavigate } from 'react-router-dom'
import { InlineWidget } from "react-calendly";

function LetsGetStarted(
    {
        heading="Let's Get Started"
    }
) {
    const navigate = useNavigate()
  return (
    <div className='LetsGetStarted-container standard-padding-space'>
        <div className='container text-center'>
            <div className='row align-items-center'>
                <div className='col-lg-12 text-center'>
                      <h3 className='body-heading mb-4'>{heading}</h3>
                    <div className='d-flex align-items-center gap-2 justify-content-lg-center justify-content-center mb-3'>
                        <img loading="lazy" src='/images/icons/lgs-phone.png' alt='phone icon' />
                        <h4 className='mb-0' style={{fontWeight:"bold"}}>Call Us:</h4>
                        <p className='body-paragraph mb-0' style={{cursor:"pointer"}} onClick={()=>{window.open("tel:+14169042013")}}>+14169042013</p>
                    </div>
                    <div className='d-flex align-items-center gap-2 justify-content-lg-center justify-content-center mb-3'>
                        <img loading="lazy" src='/images/icons/lgs-mail.png' alt='mail icon' />
                        <h4 className='mb-0' style={{fontWeight:"bold"}}>Email:</h4>
                        <p className='body-paragraph mb-0' style={{cursor:"pointer"}} onClick={()=>{window.open("mailto:info@lotusaccounting.ca")}}>info@lotusaccounting.ca</p>
                    </div>
                    <div className='d-flex align-items-center gap-2 justify-content-lg-center justify-content-center'>
                        <img loading="lazy" src='/images/icons/lgs-location.png' alt='location icon' />
                        <h4 className='mb-0' style={{fontWeight:"bold"}}>Location:</h4>
                        <p className='body-paragraph mb-0' style={{cursor:"pointer"}} onClick={()=>{window.open("https://www.google.com/maps/place/Lotus+Accounting+Professional+Corporation/@43.7894193,-79.236172,17z/data=!3m1!5s0x89d4d15a7f1afcab:0x64bc3e7ec011cee1!4m16!1m9!3m8!1s0x89d4d7675a90e4b7:0x889bff97ffa2180e!2sLotus+Accounting+Professional+Corporation!8m2!3d43.7894193!4d-79.236172!9m1!1b1!16s%2Fg%2F11fcq_d8br!3m5!1s0x89d4d7675a90e4b7:0x889bff97ffa2180e!8m2!3d43.7894193!4d-79.236172!16s%2Fg%2F11fcq_d8br?hl=en-CA&entry=ttu&g_ep=EgoyMDI1MDMwNC4wIKXMDSoASAFQAw%3D%3D")}}>
                            Suite 304-305 Milner Ave. Toronto, ON M1B 3V4</p>
                    </div>

                    <button className='blue-btn mt-4' onClick={()=>{window.open("https://calendly.com/chandrancpa")}}>Schedule a Consultation </button>
                </div>
                {/* <div className='col-lg-6 '>
                    <InlineWidget url="https://calendly.com/chandrancpa" styles={{height:"450px",margin:"0"}}/> 
                   <CalendlyWidget/>
                </div> */}
            </div>
          
        </div>
    </div>
  )
}


const CalendlyWidget = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      className="calendly-inline-widget"
      data-url="https://calendly.com/chandrancpa/30min"
      style={{ minWidth: "320px", height: "700px" }}
    ></div>
  );
};



export default LetsGetStarted